import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { TailBiting, TailBitingModuleState } from '../../model/tail-biting.model';
import * as actions from '../actions/tail-biting.actions';

export const adapter: EntityAdapter<TailBiting> = createEntityAdapter<TailBiting>();

export const initialState = {
  tailBitings: null,
  locationId: null,
  isLoaded: false,
} as TailBitingModuleState;

const TailBitingReducer = createReducer(
  initialState,
  on(actions.clearTailBitingState, (state) => ({
    ...state,
    isLoaded: false,
    tailBitings: null as TailBiting[],
    locationId: null as number,
    selectedTailBiting: undefined as TailBiting,
  })),
  on(actions.clearSelectedTailBiting, (state) => ({
    ...state,
    selectedTailBiting: undefined as TailBiting,
  })),
  on(actions.getTailBitingsSuccess, (state, { tailBitings }) => ({
    ...state,
    tailBitings,
    isLoaded: true,
  })),
  on(actions.setSelectedTailBitingSuccess, (state, { tailBiting }) => ({
    ...state,
    selectedTailBiting: tailBiting,
  })),
  on(actions.deleteTailBitingSuccess, (state, { tailBitingId }) => ({
    ...state,
    selectedTailBiting: undefined as TailBiting,
    tailBitings: [...state.tailBitings.filter((c) => c.id !== tailBitingId)],
  })),
);

export function reducer(state: TailBitingModuleState | undefined, action: Action) {
  return TailBitingReducer(state, action);
}
